import * as ko from "knockout";
import entityBase from "entityBase";

export class MeterReadingSearchCriteria extends entityBase {
  page_dir: KnockoutObservable<string>;
  sort_dir: KnockoutObservable<string>;
  sort_field: KnockoutObservable<string>;
  contract_id: KnockoutObservable<string>;
  created_dttm_from: KnockoutObservable<Date>;
  created_dttm_to: KnockoutObservable<Date>;
  Page: KnockoutObservable<number>;
  Rows: KnockoutObservable<number>;
  generalSearch: KnockoutObservable<string>;
  billTo: KnockoutObservable<string>;
  serial_id: KnockoutObservable<string>;
  model_id: KnockoutObservable<string>;
  isExport: KnockoutObservable<boolean>;

  //private
  private _generalSearch: KnockoutObservable<string>;
  _serial_id: KnockoutObservable<string>;
  _model_id: KnockoutObservable<string>;

  constructor(item) {
    super();
    this.contract_id = ko.observable(item.contract_id);
    this.created_dttm_from = ko.observable(this.formatJSONDate(item.created_dttm_from));
    this.created_dttm_to = ko.observable(this.formatJSONDate(item.created_dttm_to));
    this.Page = ko.observable(item.Page || 0);
    this.Rows = ko.observable(item.Rows || 15);
    this.page_dir = ko.observable(item.page_dir);
    this.sort_dir = ko.observable(item.sort_dir);
    this.sort_field = ko.observable(item.sort_field);
    this.billTo = ko.observable(item?.billTo);
    this._serial_id = ko.observable(item?.serial_id);
    this.serial_id = ko.computed({
      read: () => {
        return this._serial_id();
      },
      write: (value) => {
        const result = value?.trim();
        this._serial_id(result);
      },
      owner: this,
    });

    this._model_id = ko.observable(item?.model_id);
    this.model_id = ko.computed({
      read: () => {
        return this._model_id();
      },
      write: (value) => {
        const result = value?.trim();
        this._model_id(result);
      },
      owner: this,
    });

    this.isExport = ko.observable(item?.isExport ?? false);
    this._generalSearch = ko.observable(item?.generalSearch);
    this.generalSearch = ko.computed({
      read: () => {
        return this._generalSearch();
      },
      write: (value) => {
        const result = value?.trim();
        this._generalSearch(result);
      },
      owner: this,
    });
  }
}
